import ContactForm from "../components/ContactForm";

function Contact() {
  return (
    <div className="max-w-6xl mx-auto p-6 space-y-12 text-gray-800">
      {/* Page Header */}
      <div className="text-center">
        <h1 className="text-4xl font-bold text-black mb-2">Contact Jake’s RV Repair</h1>
        <p className="text-black text-lg">We’re here to get you back on the road.</p>
      </div>

      {/* Top Info */}
      <div className="space-y-4 text-base text-center items-center flex flex-col">
        <p><strong>📍 Location:</strong> Cobble Hill, BC</p>
        <p><strong>📞 Phone:</strong> <a href="tel:+12507015093" className="text-blue-600 hover:underline">(250) 701-5093</a></p>
        <p><strong>📧 Email:</strong> <a href="mailto:jakemetcalferv@outlook.com" className="text-blue-600 hover:underline">jakemetcalferv@outlook.com</a></p>
        <p><strong>🕓 Hours:</strong> Mon–Fri, 9am–5pm</p>
        <div className="flex space-x-4 mt-4 text-blue-500">
          <a href="https://www.facebook.com/people/Jakes-RV-Repair-and-Maintenance/61570466512452/#" target="_blank" rel="noreferrer" aria-label="Facebook">
            <i className="fab fa-facebook fa-xl"></i>
          </a>
        </div>
      </div>

      {/* Main Content: Contact + Map */}
      <div className="grid md:grid-cols-2 gap-10">
        {/* Left: Contact Form */}
        <ContactForm />
        
        {/* Right: Map */}
        <iframe
          title="Business Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2635.004326041069!2d-123.6365119!3d48.66716000000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x548f410bf5b0e4ef%3A0xfb0c1aa547de3172!2s1983%20Ingot%20Dr%2C%20Cobble%20Hill%2C%20BC%20V8H%200K5!5e0!3m2!1sen!2sca!4v1748148942352!5m2!1sen!2sca"
          className="w-full h-full min-h-[400px] rounded-lg shadow mb-6"
          allowFullScreen=""
          loading="lazy"
        />
      </div>  
    </div>
  );
}

export default Contact;
